import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/settings_/fleet/vehicle-models')({
  component: lazyRouteComponent(() => import('&/features/settings/fleet/pages/vehicle-models-page')),
  staticData: { titleKey: 'vehicleModels' },
});
